import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Instagram, Facebook, Globe } from "lucide-react";
import { api } from "../lib/config";

const Footer = () => {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/content/contact_info");
        setInfo(r.data?.value);
      } catch {}
    })();
  }, []);

  return (
    <footer className="bg-[#0f0f0f] border-t border-[#9A8640]/20 pt-20 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div>
            <h3 className="font-serif text-2xl text-[#DDD4B2] mb-4">Passion Verre</h3>
            <p className="text-sm text-[#DDD4B2]/70 leading-relaxed">
              Atelier artisanal de gravure et découpe laser sur mesure. Depuis 2009 près de Vienne (38).
            </p>
            <div className="flex gap-3 mt-6">
              {info?.instagram && (
                <a href={info.instagram} target="_blank" rel="noopener noreferrer" className="w-9 h-9 border border-[#9A8640]/40 flex items-center justify-center text-[#9A8640] hover:bg-[#9A8640] hover:text-[#171717] transition-all" aria-label="Instagram" data-testid="footer-instagram">
                  <Instagram size={16} />
                </a>
              )}
              {info?.facebook && (
                <a href={info.facebook} target="_blank" rel="noopener noreferrer" className="w-9 h-9 border border-[#9A8640]/40 flex items-center justify-center text-[#9A8640] hover:bg-[#9A8640] hover:text-[#171717] transition-all" aria-label="Facebook" data-testid="footer-facebook">
                  <Facebook size={16} />
                </a>
              )}
              {info?.google_business && (
                <a href={info.google_business} target="_blank" rel="noopener noreferrer" className="w-9 h-9 border border-[#9A8640]/40 flex items-center justify-center text-[#9A8640] hover:bg-[#9A8640] hover:text-[#171717] transition-all" aria-label="Fiche Google Business" data-testid="footer-google-business" title="Voir nos avis Google">
                  <Globe size={16} />
                </a>
              )}
            </div>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#9A8640] mb-5">Navigation</h4>
            <ul className="space-y-3 text-sm text-[#DDD4B2]/80">
              <li><Link to="/" className="hover:text-[#9A8640]">Accueil</Link></li>
              <li><Link to="/atelier" className="hover:text-[#9A8640]">L'Atelier</Link></li>
              <li><Link to="/professionnels" className="hover:text-[#9A8640]">Professionnels</Link></li>
              <li><Link to="/realisations" className="hover:text-[#9A8640]">Réalisations</Link></li>
              <li><Link to="/blog" className="hover:text-[#9A8640]">Blog</Link></li>
              <li><Link to="/contact" className="hover:text-[#9A8640]">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#9A8640] mb-5">Informations</h4>
            <ul className="space-y-3 text-sm text-[#DDD4B2]/80">
              <li><Link to="/mentions-legales" className="hover:text-[#9A8640]">Mentions légales</Link></li>
              <li><Link to="/cgv" className="hover:text-[#9A8640]">CGV</Link></li>
              <li><Link to="/politique-confidentialite" className="hover:text-[#9A8640]" data-testid="footer-privacy-link">Politique de confidentialité</Link></li>
              <li><Link to="/zones-desservies" className="hover:text-[#9A8640]" data-testid="footer-zones-link">Zones desservies</Link></li>
              <li><Link to="/faq" className="hover:text-[#9A8640]" data-testid="footer-faq-link">Foire aux questions</Link></li>
              <li><Link to="/politique-cookies" className="hover:text-[#9A8640]" data-testid="footer-cookies-link">Politique de cookies</Link></li>
              <li>
                <button
                  onClick={() => window.dispatchEvent(new Event("pv:openConsent"))}
                  className="hover:text-[#9A8640] text-left"
                  data-testid="footer-manage-cookies"
                >
                  Gérer mes cookies
                </button>
              </li>
              <li><Link to="/admin/login" className="hover:text-[#9A8640]" data-testid="footer-admin-link">Espace admin</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#9A8640] mb-5">Contact</h4>
            <ul className="space-y-3 text-sm text-[#DDD4B2]/80">
              {info?.address && <li className="flex items-start gap-2"><MapPin size={14} className="text-[#9A8640] mt-1 shrink-0" /> <span>{info.address}</span></li>}
              {info?.phone && <li className="flex items-center gap-2"><Phone size={14} className="text-[#9A8640] shrink-0" /> <a href={`tel:${info.phone.replace(/\s/g, '')}`} className="hover:text-[#9A8640]">{info.phone}</a></li>}
              {info?.email && <li className="flex items-center gap-2"><Mail size={14} className="text-[#9A8640] shrink-0" /> <a href={`mailto:${info.email}`} className="hover:text-[#9A8640]">{info.email}</a></li>}
              {info?.hours && <li className="flex items-start gap-2"><Clock size={14} className="text-[#9A8640] mt-1 shrink-0" /> <span>{info.hours}</span></li>}
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-[#9A8640]/20 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#DDD4B2]/50">© {new Date().getFullYear()} Passion Verre — Tous droits réservés.</p>
          <p className="text-xs text-[#DDD4B2]/50">Gravure • Découpe laser • Sablage</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
